import { useTranslation } from "react-i18next";
import { LOCALES } from "../../i18n/config";
import { setLocale } from "../../i18n/index";

/**
 * Language picker. Renders nothing while only one locale is enabled
 * (English-first, decision D1-2) — enabling a second locale in
 * `src/i18n/config.ts` makes it appear wherever it is mounted.
 */
const LanguageSwitcher = ({ className }: { className?: string }) => {
  const { t, i18n } = useTranslation();
  const enabled = LOCALES.filter((l) => l.enabled);
  if (enabled.length < 2) return null;

  return (
    <select
      className={className}
      aria-label={t("language.label")}
      value={i18n.resolvedLanguage}
      onChange={(e) => void setLocale(e.target.value)}
    >
      {enabled.map((l) => (
        <option key={l.code} value={l.code} lang={l.code}>
          {l.nativeName}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;
